import type { FC, ReactElement } from 'react';
import { useMemo } from 'react';

import { useCashierCallbackConnected } from '../../../hooks/useCashierCallbackConnected';
import { L10nText } from '../../../services/uiTranslations/reactBindings/L10nText';
import { useCoreDispatch } from '../../../store/CoreStore';
import { gameStateActions } from '../../../store/slices/game/slice';
import { popupActions } from '../../../store/slices/popup/slice';
import { Button, ButtonVariant } from '../../controls/button/Button';
import { PopupType } from '../../popup/types';

import { BlockingModalContent } from './BlockingModalContent';

export const InsufficientFundsConnected: FC = (): ReactElement => {
  const dispatch = useCoreDispatch();
  const cashierCallback = useCashierCallbackConnected();

  const actions = useMemo(() => {
    const actions = [
      <Button
        key={cashierCallback ? 'NOTHANKS' : 'OK'}
        tk={cashierCallback ? 'NOTHANKS' : 'OK'}
        variant={cashierCallback ? ButtonVariant.MAIN : ButtonVariant.ACCENT}
        onClick={() => {
          dispatch(gameStateActions.setBalanceCheckCount(0));
          dispatch(popupActions.dismissPopup(PopupType.InsufficientFunds));
        }}
      />,
    ];
    if (cashierCallback) {
      actions.push(
        <Button
          key="TAKEMETHERE"
          tk="TAKEMETHERE"
          variant={ButtonVariant.ACCENT}
          onClick={() => {
            dispatch(gameStateActions.setBalanceCheckCount(0));
            dispatch(popupActions.dismissPopup(PopupType.InsufficientFunds));
            cashierCallback();
          }}
        />
      );
    }
    return actions;
  }, [cashierCallback, dispatch]);

  return (
    <BlockingModalContent title={<L10nText tk="INSUFFICIENTFUNDS" />} actions={actions}>
      <L10nText tk={cashierCallback ? 'LOWBALANCE' : 'LOWBALANCE_SHORT'} />
    </BlockingModalContent>
  );
};
